import React, { Component } from "react";
import "./SampleVoterId.scss";
import VoterIDFront from "../../../assets/docSampleImages/VoterID FRONT.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Voter ID back.jpg";
export interface IViewSampleVoterIDPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SampleVoterIDPopup = (props: IViewSampleVoterIDPopup) => {
  const popupRefFour = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (popupRefFour.current !== null && popupRefFour.current !== undefined) {
        props?.setShowPopup(); // Close popup if clicked outside
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);
  return (
    <div
      className={`overlay-VoterID ${props?.parentClassName ?? ""}`}
      ref={popupRefFour}
    >
      <div className="popup-VoterID">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Uploading Voter ID</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Voter ID in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="voterId-Row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image"
                  />
                  <div className="badge">1</div>
                </div>

                <label className="Aadhar-Label">FRONT</label>
              </span>
              <span className="Aadhar-Front-row ml-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image"
                  />
                  <div className="badge">2</div>
                </div>

                <label className="Aadhar-Label">BACK</label>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SampleVoterIDPopup;
